import React from 'react';
import Timer from '../component/Timer';


export default function MiddleSection(){
    return(

        <div className="subDivStyle">
          <Timer/>
        </div>
    )
}